import React, { useEffect } from "react";
import { useState } from "react";
import { ShimmerPostDetails } from "react-shimmer-effects";
import parse from "react-html-parser";

import { getSupportData } from "@/api/faq";
import Header from "@/components/common/header/DefaultHeader";
import MobileMenu from "@/components/common/header/MobileMenu";
import PageFooter from "@/components/common/PageFooter";
import PopupSignInUp from "@/components/common/PopupSignInUp";
import MetaComponent from "@/components/common/MetaComponent";
import { formatCmsTextToHtml } from "@/utils/textParser";
import "./index.css";

const metadata = {
  title: "Hubzu | Terms",
};


const TermsAndCondition = () => {
  const [footerCmsData, setFooterCmsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cmsData, setCmsData] = useState([]);

  useEffect(() => {
    const getCMSData = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await getSupportData("terms");
        if (data?.results) {
          setCmsData(data?.results);
        } else {
          throw new Error("No data found");
        }
      } catch (err) {
        setError(err?.message);
      } finally {
        setLoading(false);
      }
    };

    getCMSData();
  }, []);

  const renderContent = () => {
    if (loading) {
      return (
        <div className="loading-section">
          <ShimmerPostDetails card cta variant="EDITOR" />
        </div>
      );
    }

    if (error || !Array.isArray(cmsData) || cmsData.length === 0) {
      return (
        <div className="d-flex align-items-center justify-content-center vh-100">
          <div className="text-center">
            <div className="alert alert-danger" role="alert">
              <h2 className="alert-heading">Unable to Load Content</h2>
              <p>
                {error ||
                  "Sorry, something went wrong while fetching the data. Please try again later."}
              </p>
              <hr />
              <button
                className="btn btn-thm btn-primary"
                onClick={() => window.location.reload()}
              >
                Retry
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="termsContainer">
        <h1 className="termsheadingCls">{cmsData[0]?.title}</h1>
        <p className="termsEffectiveDate">
          <strong>
            Updated: <span>{cmsData[0]?.effectiveDate}</span>
          </strong>
        </p>
        <p className="termsDescriptionFirst">
          {parse(formatCmsTextToHtml(cmsData[0]?.decriptionFirst))}
        </p>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.glossaryText))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.hubzuServicesFees))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(
              formatCmsTextToHtml(cmsData[0]?.eligibilityAndResponsibilty)
            )}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.hubzuPlatform))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.biddingAndBuying))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.propertyStatus))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.privacy))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.indemnity))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.liabiltyLimitation))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.legalCompliance))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.noAgency))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.general))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.agentsTermsAndConditions))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(
              formatCmsTextToHtml(cmsData[0]?.additionalTermsAndCondition)
            )}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(
              formatCmsTextToHtml(cmsData[0]?.additionalTermsAndConditionNPL)
            )}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(
              formatCmsTextToHtml(cmsData[0]?.additionalTermsAndConditionCREP)
            )}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.communicationConsent))}
          </p>
        </div>
        <div className="termsGlossaryContainer">
          <p className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(cmsData[0]?.smsMessage))}
          </p>
        </div>
      </div>
    );
  };

  return (
    <>
      <MetaComponent meta={metadata} />
      <div>
        <div className="d-flex flex-column min-vh-100">
          <Header />
          <MobileMenu />
          <PopupSignInUp />

          <div
            style={{
              flex: 1,
              marginTop: "calc(3.5rem + 1.75vw)",
              marginBottom: "calc(3.5rem + 1.75vw)",
            }}
            className="flex-grow-1"
          >
            {renderContent()}
          </div>

          <PageFooter footerCmsData={footerCmsData} showPartners={false} />
        </div>
      </div>
    </>
  );
};

export default TermsAndCondition;
